import axios from 'axios'
import jwtDecode from 'jwt-decode';
import { BaseList, BaseResponse } from '../dto/BaseResponse';
import { LoginResponse } from '../redux/AuthRedux';
setHeaderAxios();

const apiUrl = process.env.REACT_APP_API_URL;
const timeOut=45000;
export function getToken() {
    var data = localStorage.getItem('ls.CLICKMERCI:STOREPANEL');
    if (data) {
        var jsonData = JSON.parse(data) as LoginResponse;
        if (jsonData) {
            return jsonData.access_token;
        }
    }
    return null;
}
function setHeaderAxios() {
    if (isAuthTokenValid())
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();
}
export const saveToken = (token: any) => {
    localStorage.setItem('ls.CLICKMERCI:STOREPANEL', JSON.stringify(token));
    setHeaderAxios();
};
export const clearToken = () => {
    localStorage.removeItem('ls.CLICKMERCI:STOREPANEL');
};
export function isAuthTokenValid() {
    let access_token = getToken();
    if (!access_token)
        return false;
    const decoded = jwtDecode(access_token) as any;

    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
        console.warn('access token expired');
        return false;
    }

    return true;
};
export function getList<T>(resource: any, params: any): Promise<BaseList<T>> {
    let query = ''
    Object.keys(params).map(p => {
        return query = query + `${p}=${params[p]}&`
    })
    return new Promise((resolve, reject) => {
        axios.get<BaseList<T>>(`${apiUrl}/${resource}?${query}`, {
            headers: { 'Content-Type': 'application/json' },timeout:timeOut
        })
            .then(result => {
                result.data.success = true;
                return resolve(result.data);
            })
            .catch(err => {
                console.log(err);

                return resolve({ items: [], page: 0, pageSize: 10, totalCount: 0, success: false });

            })
    });
}
export function getOne<T>(resource: any, params: any): Promise<BaseResponse<T>> {
    return new Promise((resolve, reject) => {
        axios.get<BaseResponse<T>>(`${apiUrl}/${resource}`, {
            headers: { 'Content-Type': 'application/json' }, params: params,timeout:timeOut
        })
            .then(result => {
                return resolve(result.data);
            })
            .catch(err => {
                console.log(err)
                if (err.response) {
                    return resolve({ success: false, entity: {} as any, message: err.response });
                } else {
                    return resolve({ success: false, message: "", entity: {} as any });
                }
            })
    })
}

export function Post<T>(resource: string, params = {}): Promise<BaseResponse<T>> {
    const headers = {
        'Content-Type': 'application/json',
    }
    return new Promise((resolve, reject) => {
        return axios.post<BaseResponse<T>>(`${apiUrl}/${resource}`, params, { headers: headers,timeout:timeOut })
            .then(result => {
                return resolve(result.data);
            })
            .catch(error => {
                if (error.response && error.response.data)
                    return resolve({ message: error.response.data, success: false, entity: {} as any });
                else
                    return resolve({ success: false, message: "", entity: {} as any });
            })
    });
}

export function Put<T>(resource = "", params: any): Promise<BaseResponse<T>> {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json',
        }
        return axios.put<BaseResponse<T>>(`${apiUrl}/${resource}`, params, { headers: headers,timeout:timeOut })
            .then(result => {
                // console.log(result)
                return resolve(result.data);
            })
            .catch(error => {
                console.log(error);
                if (error.response && error.response.data)
                    return resolve({ message: error.response.data, success: false, entity: {} as any });
                else
                    return resolve({ success: false, message: "", entity: {} as any });
            })
    });
}
export function Delete(resource = "", params = {}) {
    const headers = {
        'Content-Type': 'application/json',
    }
    return new Promise((resolve, reject) => {
        axios.delete(`${apiUrl}/${resource}`, {
            headers: headers,timeout:timeOut,
            data: params,

        })
            .then(result => {
                return resolve(result.data);
            })
            .catch(err => {
                return resolve(false);
            })
    });
}


export function PostForm<T>(resource = "", params: any): Promise<BaseResponse<T>> {

    return new Promise((resolve, rejects) => {

        const upload_headers = {
            'accept': '*/*',
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + getToken()
        }
        return axios.post<BaseResponse<T>>(`${apiUrl}/${resource}`, params, {
            headers: upload_headers,timeout:timeOut
        })
            .then(result => {
                // console.log(result)
                return resolve(result.data);
            })
            .catch(error => {
                console.log(error);
                if (error.response && error.response.data)
                    return resolve({ message: error.response.data, success: false, entity: {} as any });
                else
                    return resolve({ success: false, message: "", entity: {} as any });
            })
    })
}
export function PutForm<T>(resource: any, params: any): Promise<BaseResponse<T>> {
    return new Promise((resolve, rejects) => {
        const upload_headers = {
            'accept': '*/*',
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + getToken()
        }
        return axios.put<BaseResponse<T>>(`${apiUrl}/${resource}`, params, {
            headers: upload_headers,timeout:timeOut
        })
        .then(result => {
            // console.log(result)
            return resolve(result.data);
        })
        .catch(error => {
            console.log(error);
            if (error.response && error.response.data)
                return resolve({ message: error.response.data, success: false, entity: {} as any });
            else
                return resolve({ success: false, message: "", entity: {} as any });
        })
    });
}

